import { setActiveAccount } from '@customerio/hydra-session-state';
import { navigateExternal } from '@/utils/navigate';

/**
 * switchAccount selects the account the current login operates on and reloads
 * into it. Unlike switching between logins (changeToSession), this stays on the
 * same session cookie and only changes the per-tab X-Active-Account-Id header;
 * the full reload ensures per-account data is refetched fresh.
 */
export function switchAccount(accountId: number): void {
  setActiveAccount(accountId);
  // No account in the URL: land on the dashboard and fully reload so all
  // per-account data is refetched under the newly selected account.
  navigateExternal('/');
}
